import React, {useEffect, useState} from "react";

import {epdAstralService, companyService, systemService} from "../../../../services";
import {Alert, Select} from "antd";
import {Button, Col, Form, Icon, Input, Modal, notification, Row, Steps, Upload} from "antd";
import InputField from "../../../input-field";
import FieldBlock from "../../../field-block";
import SelectField from "../../../select-field";
import DividerBlock from "../../../divider-block";
import Spinner from "../../../spinner";
import {getSystemInfo, isValidSystemSetup, getCertificate} from "crypto-pro";
import Certificate from "../create-signature/certificate";
import i18n from "../../../../i18n";


export default function ModalLoginApiCompany({
                                               type = 'login',
                                               legalEntityId,
                                               legalEntityName,
                                               isShow,
                                               onCloseModal,
                                               setIsNeedUpdate,
                                               edit = false
                                             }) {
  const {Option} = Select;
  //const [legal_entity_id, setLegalEntityId] = useState('');
  const [cert, setCert] = useState(null);
  const [certificate, setCertificate] = useState(null);
  const [actionType, setActionType] = useState(null);
  const [regCode, setRegCode] = useState('');
  const [company, setCompany] = useState('');
  const [region, setRegion] = useState('');
  const [city, setCity] = useState('');
  const [fieldsErrors, setFieldsErrors] = useState(null);
  const [message, setMessage] = useState('');
  const [regionList, setRegionList] = useState(null);
  const [localitiesList, setLocalitiesList] = useState(null);

  const [companiesList, setCompaniesList] = useState([]);

  const [isNeedCheckSystemInfo, setNeedCheckSystemInfo] = useState(true);
  const [systemInfo, setSystemInfo] = useState(null);
  const [systemInfoError, setSystemInfoError] = useState(null);

  function getRegions(regionName, setRegion) {
      systemService.getRegionsList(regionName)
          .then(data => {
              setRegion(data);
          })
          .catch();
  }

  function getLocalities(localityName, parentGuid, setLocalities) {
      systemService.getLocalitiesList(localityName, parentGuid)
          .then(data => {
              setLocalitiesList(data);
          })
          .catch();
  }

  let bigButtonStyle = {
    width: '200px', height: '43px', background: '#1CAA53', position: 'static', borderRadius: '10px'
  };

  const getFieldErrors = (nameField) => {
    return (fieldsErrors && typeof fieldsErrors[nameField] !== "undefined") ? fieldsErrors[nameField][0] : null;
  };

  const checkSystemInfoErrors = async () => {
    try {
      setSystemInfo({
        ...await getSystemInfo(),
        isValidSystemSetup: await isValidSystemSetup()
      });
    } catch (error) {
      setSystemInfoError(error.message);
    }
  }

  async function getBase64Cert() {
    if(certificate) {
      let originalCert = await getCertificate(certificate.thumbprint)

      let ownerInfo = await certificate.getOwnerInfo();

      setCompany(ownerInfo.filter(info => info.title === 'Владелец')[0]['description']);
      setRegion(ownerInfo.filter(info => info.title === 'Регион')[0]['description']);
      setCity(ownerInfo.filter(info => info.title === 'Город')[0]['description']);

      let certB64 = await originalCert.exportBase64();
      const blob = new Blob([certB64], {type: "application/x-x509-ca-cert"});
      const file = new File([blob], `certificate.cer`, {type: blob.type, lastModified: Date.now()});
      setCert(file);
    }
  }

  useEffect(() => {
    if (isNeedCheckSystemInfo && isShow) {
      checkSystemInfoErrors().then(r => {
          setNeedCheckSystemInfo(false);
        }
      );
    }
  }, [isNeedCheckSystemInfo]);

  useEffect(() => {
    getBase64Cert();
  }, [certificate]);

  const uploaderCert = {
    multiple: false,
    showUploadList: true,
    onRemove: () => {
      setCert(null);
    },
    beforeUpload: (file) => {
      setCert(file);
      return false;
    },
    listType: 'file'
  };

  const registerApiCompany = () => {
    epdAstralService.registerApiCompany({cert: cert, legal_entity_id: legalEntityId, company: company, region: region, city: city})
      .then(resp => {
        if (resp.status === 'success') {
          notification.success({
            message: i18n.t('components.notification.titles.registerApiCompany'),
            description: resp.message,
          });
          onCloseModal(null);
          setIsNeedUpdate(true);
        } else if (resp.status === 'error') {
          setFieldsErrors(resp.errors);
          notification.error({
            message: i18n.t('components.notification.titles.registerApiCompany'),
            description: resp.message,
          });
        }
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.registerApiCompany'),
          description: err,
        });
      });
  }

  const editApiCompany = () => {
    epdAstralService.editApiCompany({
      cert: cert,
      legal_entity_id: legalEntityId,
      actionType: actionType,
      company: company,
      region: region,
      city: city
    })
      .then(resp => {
        if (resp.status === 'success') {
          notification.success({
            message: i18n.t('components.notification.titles.editApiCompany'),
            description: resp.message,
          });
          onCloseModal(null);
          setIsNeedUpdate(true);
        } else if (resp.status === 'error') {
          setFieldsErrors(resp.errors);
          notification.error({
            message: i18n.t('components.notification.titles.editApiCompany'),
            description: resp.message,
          });
        }
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.editApiCompany'),
          description: err,
        });
      });
  }

  useEffect(() => {
    setNeedCheckSystemInfo(isShow);
    if (isShow) {
      companyService
        .getEntitiesList()
        .then(resp => {
          setCompaniesList(resp);
        })
        .catch(err => {
          notification.error({
            message: i18n.t('components.notification.titles.getEntitiesList'),
            description: err
          });
        });
    }
  }, [isShow]);

  let modalTitle = i18n.t('modals.modalLoginApiCompany.modalTitle.default');
  if (type === 'register') {
    modalTitle = i18n.t('modals.modalLoginApiCompany.modalTitle.register');
  } else if (type === 'edit') {
    modalTitle = i18n.t('modals.modalLoginApiCompany.modalTitle.edit');
  }


  return (<Modal
      title={<div>{modalTitle}</div>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        onCloseModal(null);
        setSystemInfoError(null);
        setSystemInfo(null);
      }}
      forceRender={true}
      footer={<div></div>}
    >
      <>
        <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
          <Col span={24}>
            <h2>{legalEntityName}</h2>
          </Col>
        </Row>
        <Spinner loading={isNeedCheckSystemInfo} label={i18n.t('modals.modalLoginApiCompany.loading')}>
          {(systemInfoError !== null) &&
            <>
              <Alert type="error" message={<div>
                <span>{systemInfoError}</span>
                <div style={{marginTop: 20}}>
                  <ol>
                    <li>{i18n.t('modals.modalLoginApiCompany.errorMessage.1')} <a
                        href='https://www.cryptopro.ru/sites/default/files/products/cades/demopage/cades_bes_sample.html'
                        style={{
                          fontWeight: "bold",
                          color: "green",
                          textDecoration: "underline"
                        }}
                      > {i18n.t('modals.modalLoginApiCompany.errorMessage.2')}</a> {i18n.t('modals.modalLoginApiCompany.errorMessage.3')}
                    </li>
                    <li>{i18n.t('modals.modalLoginApiCompany.errorMessage.4')}
                      <a style={{
                        fontWeight: "bold",
                        color: "green",
                        textDecoration: "underline"
                      }}
                        href='https://docs.cryptopro.ru/cades/plugin/plugin-installation-windows'> {i18n.t('modals.modalLoginApiCompany.errorMessage.5')}</a>
                    </li>
                  </ol>
                </div>
              </div>
              } banner/>
              <div style={{marginTop: 20}}>
                <Button
                  type="primary" style={bigButtonStyle}
                  onClick={() => window.location.reload()}
                >
                  {i18n.t('modals.modalLoginApiCompany.buttons.updatePage')}
                </Button>
              </div>
            </>
          }
          {systemInfoError === null &&
            <>
              {type==='edit' &&
              <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
                <Col span={24}>
                  <SelectField
                      title={i18n.t('modals.modalLoginApiCompany.fields.typeAction.title')}
                      name="typeAction"
                      selectedValue={actionType}
                      required={true}
                      style={{width: "100%"}}
                      values={[
                          { Id: 'change_data', Name: i18n.t('modals.modalLoginApiCompany.fields.typeAction.values.changeData') },
                          { Id: 'change_cert', Name: i18n.t('modals.modalLoginApiCompany.fields.typeAction.values.changeCert') }
                      ]}
                      onChange={(value) => {
                          setActionType(value);
                      }}
                      getErrors={getFieldErrors}
                  />
                </Col>
              </Row>}
              {(false && (actionType === 'change_data' || type=== 'register')) && <>
              <DividerBlock label={i18n.t('modals.modalLoginApiCompany.divider.address')}/>
              <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
                <Col sm={12} xs={24}>
                  <SelectField
                      title={i18n.t('modals.modalLoginApiCompany.fields.regCode.title')}
                      name="regCode"
                      selectedValue={regCode}
                      values={regionList}
                      onChange={(value) => {
                        setRegCode(value);
                      }}
                      onSearch={(value) => {
                          if (value.length > 2) {
                              getRegions(value, (data) => {
                                setRegionList(data);
                              });
                          }
                      }}
                      getErrors={getFieldErrors}
                      placeholder={i18n.t('modals.modalLoginApiCompany.fields.regCode.placeholder')}
                      notFoundText={null}
                      showArrow={false}
                      style={{ width: "100%" }}
                  />
                </Col>
                <Col sm={12} xs={24}>
                  <SelectField
                      title={i18n.t('modals.modalLoginApiCompany.fields.city.title')}
                      name="city"
                      selectedValue={city}
                      values={localitiesList}
                      isDisabled={(!regCode)}
                      onChange={(value) => {
                        setCity(value);
                      }}
                      onSearch={(value) => {
                          if (value.length >= 1) {
                              getLocalities(value, regCode, (data) => {
                                setLocalitiesList(data);
                              });
                          }
                      }}
                      getErrors={getFieldErrors}
                      placeholder={i18n.t('modals.modalLoginApiCompany.fields.city.placeholder')}
                      notFoundText={null}
                      showArrow={false}
                      style={{ width: "100%" }}
                  />
                </Col>
              </Row></>}
              {(true) && <>
              
              {false && 
              <>
              <DividerBlock label={i18n.t('modals.modalLoginApiCompany.divider.cert')}/>
              <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
                <Col lg={24} md={24} sm={24} xs={24}>
                    <FieldBlock name="cert" getErrors={getFieldErrors}>
                        <Upload className="single-btn-upload" {...uploaderCert}>
                            <Button htmlType="button">
                              {i18n.t('modals.modalLoginApiCompany.buttons.cert')}
                            </Button>
                        </Upload>
                    </FieldBlock>
                </Col>
              </Row></>}
              <DividerBlock label={i18n.t('modals.modalJoinCompany.divider.certificate')}/>
              <FieldBlock name="cert" getErrors={getFieldErrors}>
                <Certificate onChange={setCertificate}/>
              </FieldBlock>
              </>
              }
              <Row gutter={[16, 24]} style={{marginBottom: "34px"}}>
                <Col>
                  {type === 'register' && (
                    <Button type="primary" style={bigButtonStyle}
                            onClick={() => registerApiCompany()}
                            disabled={legalEntityId === 0 || legalEntityId === ''}>
                      {i18n.t('main.buttons.send')}
                    </Button>
                  )}
                  {type === 'edit' && (
                    <Button type="primary" style={bigButtonStyle}
                            onClick={() => editApiCompany()}
                            disabled={legalEntityId === 0 || legalEntityId === '' || actionType === null || actionType === '' 
                            || cert === null}>
                      {i18n.t('main.buttons.send')}
                    </Button>
                  )}
                </Col>
              </Row>
            </>
          }
        </Spinner>
      </>
    </Modal>
  )
}
